import { trimInput } from '../../../utils';
import { emailRegex } from './constants';

export const getEmailInvalidErrorMessage = (
  numberOfInvalidEmails,
  invalidEmailErrorMsg,
  multipleInvalidEmailsErrorMsg
) => {
  if (numberOfInvalidEmails === 0) {
    return '';
  }
  return numberOfInvalidEmails === 1
    ? invalidEmailErrorMsg
    : multipleInvalidEmailsErrorMsg;
};

export const validateRepeatedEmails = (addedEmails) => {
  const uniqueEmails = [];
  const result = {
    emails: [],
    numberOfInvalidEmails: addedEmails.numberOfInvalidEmails,
    numberOfDuplicatedEmails: 0,
  };

  result.emails = addedEmails.emails.map((email) => {
    let duplicated = false;
    if (uniqueEmails.indexOf(email.label) === -1) {
      uniqueEmails.push(email.label);
    } else {
      duplicated = true;
      result.numberOfDuplicatedEmails += 1;
    }
    return {
      ...email,
      duplicated,
    };
  });
  return result;
};

export const getEmailsToAdd = (existingEmails, inputEmails) => {
  const emailsToAdd = [];
  let numberOfInvalidEmailsToAdd = 0;
  let emailIndex = existingEmails.length
    ? existingEmails[existingEmails.length - 1].value + 1
    : 0;

  inputEmails.forEach((item) => {
    const email = trimInput(item).toLowerCase();
    const isEmailAlreadyAdded = existingEmails.some(
      ({ label }) => label === email
    );
    if (email !== '' && !isEmailAlreadyAdded) {
      const valid = emailRegex.test(email);
      emailsToAdd.push({ label: email, value: emailIndex, valid });
      emailIndex += 1;
      if (!valid) {
        numberOfInvalidEmailsToAdd += 1;
      }
    }
  });
  return {
    emailsToAdd,
    numberOfInvalidEmailsToAdd,
  };
};
